import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  DeleteMarathonsParams,
  DeleteMarathonsResponse,
} from "api/api/marathonsApi/types";
import axios from "axios";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";

export const deleteMarathons = createAsyncThunk<
  DeleteMarathonsResponse,
  DeleteMarathonsParams
>(
  "marathons/deleteMarathons",
  async ({ marathonId }, { rejectWithValue }) => {
    try {
      const data = await MarathonsAPI.deleteMarathons({ marathonId });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while deleting marathon", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      console.error("Error while deleting marathon", error);
      return rejectWithValue("Что-то пошло не так... Попробуйте обновить страницу");
    }
  }
);
